export default {
    AP: {
        en: 'ARIPO',
        cn: '非洲地区工业产权组织',
        tw: '非洲地區工業產權組織',
        jp: 'アフリカ地域工業所有権機関',
        de: 'Afrikanische Regionalorganisation für geistiges Eigentum'
    },
    AR: {
        en: 'Argentina',
        cn: '阿根廷',
        tw: '阿根廷',
        jp: 'アルゼンチン',
        de: 'Argentinien'
    },
    AT: {
        en: 'Austria',
        cn: '奥地利',
        tw: '奧地利',
        jp: 'オーストリア',
        de: 'Österreich'
    },
    AU: {
        en: 'Australia',
        cn: '澳大利亚',
        tw: '澳大利亞',
        jp: 'オーストラリア',
        de: 'Australien'
    },
    BA: {
        en: 'Bosnia and Herzegovina',
        cn: '波斯尼亚和黑塞哥维那',
        tw: '波士尼亞赫塞哥維納',
        jp: 'ボスニア・ヘルツェゴビナ',
        de: 'Bosnien und Herzegowina'
    },
    BE: {
        en: 'Belgium',
        cn: '比利时',
        tw: '比利時',
        jp: 'ベルギー',
        de: 'Belgien'
    },
    BG: {
        en: 'Bulgaria',
        cn: '保加利亚',
        tw: '保加利亞',
        jp: 'ブルガリア',
        de: 'Bulgarisch'
    },
    BR: {
        en: 'Brazil',
        cn: '巴西',
        tw: '巴西',
        jp: 'ブラジル',
        de: 'Brasilien'
    },
    BY: {
        en: 'Belarus',
        cn: '白俄罗斯',
        tw: '白俄羅斯',
        jp: 'ベラルーシ',
        de: 'Weißrussland'
    },
    CA: {
        en: 'Canada',
        cn: '加拿大',
        tw: '加拿大',
        jp: 'カナダ',
        de: 'Kanada'
    },
    CH: {
        en: 'Switzerland',
        cn: '瑞士',
        tw: '瑞士',
        jp: 'スイス',
        de: 'Schweiz'
    },
    CL: {
        en: 'Chile',
        cn: '智利',
        tw: '智利',
        jp: 'チリ',
        de: 'Chile'
    },
    CN: {
        en: 'China',
        cn: '中国',
        tw: '中國',
        jp: '中国',
        de: 'China'
    },
    CO: {
        en: 'Colombia',
        cn: '哥伦比亚',
        tw: '哥倫比亞',
        jp: 'コロンビア',
        de: 'Kolumbien'
    },
    CR: {
        en: 'Costa Rica',
        cn: '哥斯达黎加',
        tw: '哥斯達黎加',
        jp: 'コスタリカ',
        de: 'Costa Rica'
    },
    CS: {
        en: 'Czech Slovak Rep.',
        cn: '捷克和斯洛伐克共和国',
        tw: '捷克和斯洛伐克共和國',
        jp: 'チェコスロバキア共和国',
        de: 'Tschechische Slowakische Rep.'
    },
    CU: {
        en: 'Cuba',
        cn: '古巴',
        tw: '古巴',
        jp: 'キューバ',
        de: 'Kuba'
    },
    CY: {
        en: 'Cyprus',
        cn: '塞浦路斯',
        tw: '塞浦路斯',
        jp: 'キプロス',
        de: 'Zypern'
    },
    CZ: {
        en: 'Czech Republic',
        cn: '捷克',
        tw: '捷克',
        jp: 'チェコ',
        de: 'Czech'
    },
    DD: {
        en: 'East Germany',
        cn: '东德',
        tw: '東德',
        jp: '東ドイツ',
        de: 'Ost-Deutschland'
    },
    DE: {
        en: 'Germany',
        cn: '德国',
        tw: '德國',
        jp: 'ドイツ',
        de: 'Deutschland'
    },
    DK: {
        en: 'Denmark',
        cn: '丹麦',
        tw: '丹麥',
        jp: 'デンマーク',
        de: 'Dänemark'
    },
    DO: {
        en: 'Dominican Rep.',
        cn: '多米尼加共和国',
        tw: '多米尼加共和國',
        jp: 'ドミニカ共和国',
        de: 'Dominikanische Republik'
    },
    DZ: {
        en: 'Algeria',
        cn: '阿尔及利亚',
        tw: '阿爾及利亞',
        jp: 'アルジェリア',
        de: 'Algerien'
    },
    EA: {
        en: 'EAPO',
        cn: '欧亚专利局',
        tw: '歐亞專利局',
        jp: 'ユーラシア特許庁',
        de: 'EAPO'
    },
    EC: {
        en: 'Ecuador',
        cn: '厄瓜多尔',
        tw: '厄瓜多爾',
        jp: 'エクアドル',
        de: 'Ecuador'
    },
    EE: {
        en: 'Estonia',
        cn: '爱沙尼亚',
        tw: '愛沙尼亞',
        jp: 'エストニア',
        de: 'Estland'
    },
    EG: {
        en: 'Egypt',
        cn: '埃及',
        tw: '埃及',
        jp: 'エジプト',
        de: 'Ägypten'
    },
    EM: {
        en: 'EUIPO',
        cn: '欧盟知识产权局',
        tw: '歐盟知識產權局',
        jp: 'EU知的財産局',
        de: 'Amt der EU für geistiges Eigentum'
    },
    EP: {
        en: 'EPO',
        cn: '欧洲',
        tw: '歐洲',
        jp: 'ヨーロッパ',
        de: 'EPO'
    },
    ES: {
        en: 'Spain',
        cn: '西班牙',
        tw: '西班牙',
        jp: 'スペイン',
        de: 'Spanien'
    },
    EU: {
        en: 'EUIPO',
        cn: '欧盟',
        tw: '歐盟',
        jp: '欧州連合知的財産庁',
        de: 'EU'
    },
    FI: {
        en: 'Finland',
        cn: '芬兰',
        tw: '芬蘭',
        jp: 'フィンランド',
        de: 'Finnland'
    },
    FR: {
        en: 'France',
        cn: '法国',
        tw: '法國',
        jp: 'フランス',
        de: 'Frankreich'
    },
    GB: {
        en: 'Great Britain',
        cn: '英国',
        tw: '英國',
        jp: 'イギリス',
        de: 'Great Britain'
    },
    GC: {
        en: 'GCC',
        cn: '海湾地区阿拉伯国家合作委员会专利局',
        tw: '海灣地區阿拉伯國家合作委員會專利局',
        jp: 'ベイエリアアラブ諸国協力協議会特許事務所',
        de: 'Gulf Cooperation Council (GCC)'
    },
    GE: {
        en: 'Georgia',
        cn: '格鲁吉亚',
        tw: '格魯吉亞',
        jp: 'ジョージア',
        de: 'Georgia'
    },
    GR: {
        en: 'Greece',
        cn: '希腊',
        tw: '希臘',
        jp: 'ギリシャ',
        de: 'Griechenland'
    },
    GT: {
        en: 'Guatemala',
        cn: '危地马拉',
        tw: '危地馬拉',
        jp: 'グアテマラ',
        de: 'Guatemala'
    },
    HK: {
        en: 'China Hong Kong',
        cn: '中国香港',
        tw: '中國香港',
        jp: '中国香港',
        de: 'China Hong Kong'
    },
    HN: {
        en: 'Honduras',
        cn: '洪都拉斯',
        tw: '洪都拉斯',
        jp: 'ホンジュラス',
        de: 'Honduras'
    },
    HR: {
        en: 'Croatia',
        cn: '克罗地亚',
        tw: '克羅地亞',
        jp: 'クロアチア',
        de: 'Kroatien'
    },
    HU: {
        en: 'Hungary',
        cn: '匈牙利',
        tw: '匈牙利',
        jp: 'ハンガリー',
        de: 'Ungarn'
    },
    ID: {
        en: 'Indonesia',
        cn: '印度尼西亚',
        tw: '印度尼西亞',
        jp: 'インドネシア',
        de: 'Indonesien'
    },
    IE: {
        en: 'Ireland',
        cn: '爱尔兰',
        tw: '愛爾蘭',
        jp: 'アイルランド',
        de: 'Irland'
    },
    IL: {
        en: 'Israel',
        cn: '以色列',
        tw: '以色列',
        jp: 'イスラエル',
        de: 'Israel'
    },
    IN: {
        en: 'India',
        cn: '印度',
        tw: '印度',
        jp: 'インド',
        de: 'Indien'
    },
    IS: {
        en: 'Iceland',
        cn: '冰岛',
        tw: '冰島',
        jp: 'アイスランド',
        de: 'Island'
    },
    IT: {
        en: 'Italy',
        cn: '意大利',
        tw: '意大利',
        jp: 'イタリア',
        de: 'Italien'
    },
    JP: {
        en: 'Japan',
        cn: '日本',
        tw: '日本',
        jp: '日本',
        de: 'Japan'
    },
    KE: {
        en: 'Kenya',
        cn: '肯尼亚',
        tw: '肯尼亞',
        jp: 'ケニア',
        de: 'Kenya'
    },
    KR: {
        en: 'Korea',
        cn: '韩国',
        tw: '韓國',
        jp: '韓国',
        de: 'Südkorea'
    },
    KZ: {
        en: 'Kazakhstan',
        cn: '哈萨克斯坦',
        tw: '哈薩克斯坦',
        jp: 'カザフスタン',
        de: 'Kasachstan'
    },
    LT: {
        en: 'Lithuania',
        cn: '立陶宛',
        tw: '立陶宛',
        jp: 'リトアニア',
        de: 'Litauen'
    },
    LU: {
        en: 'Luxembourg',
        cn: '卢森堡',
        tw: '盧森堡',
        jp: 'ルクセンブルグ',
        de: 'Luxemburg'
    },
    LV: {
        en: 'Latvia',
        cn: '拉脱维亚',
        tw: '拉脫維亞',
        jp: 'ラトビア',
        de: 'Lettland'
    },
    MC: {
        en: 'Monaco',
        cn: '摩纳哥',
        tw: '摩納哥',
        jp: 'モナコ',
        de: 'Monaco'
    },
    MD: {
        en: 'Moldova',
        cn: '摩尔多瓦',
        tw: '摩爾多瓦',
        jp: 'モルドバ',
        de: 'Moerdawa'
    },
    MN: {
        en: 'Mongolia',
        cn: '蒙古',
        tw: '蒙古',
        jp: 'モンゴル',
        de: 'Mongolei'
    },
    MT: {
        en: 'Malta',
        cn: '马耳他',
        tw: '馬耳他',
        jp: 'マルタ',
        de: 'Malta'
    },
    MW: {
        en: 'Malawi',
        cn: '马拉维',
        tw: '馬拉維',
        jp: 'マラウイ',
        de: 'Malawi'
    },
    MX: {
        en: 'Mexico',
        cn: '墨西哥',
        tw: '墨西哥',
        jp: 'メキシコ',
        de: 'Mexiko'
    },
    MY: {
        en: 'Malaysia',
        cn: '马来西亚',
        tw: '馬來西亞',
        jp: 'マレーシア',
        de: 'Malaysia'
    },
    NI: {
        en: 'Nicaragua',
        cn: '尼加拉瓜',
        tw: '尼加拉瓜',
        jp: 'ニカラグア',
        de: 'Nicaragua'
    },
    NL: {
        en: 'Netherlands',
        cn: '荷兰',
        tw: '荷蘭',
        jp: 'オランダ',
        de: 'Niederlande'
    },
    NO: {
        en: 'Norway',
        cn: '挪威',
        tw: '挪威',
        jp: 'ノルウェー',
        de: 'Norwegen'
    },
    NZ: {
        en: 'New Zealand',
        cn: '新西兰',
        tw: '新西蘭',
        jp: 'ニュージーランド',
        de: 'Neuseeland'
    },
    OA: {
        en: 'OAPI',
        cn: '非洲知识产权组织',
        tw: '非洲知識產權組織',
        jp: 'アフリカ知的財産機関',
        de: 'OAPI'
    },
    PA: {
        en: 'Panama',
        cn: '巴拿马',
        tw: '巴拿馬',
        jp: 'パナマ',
        de: 'Panama'
    },
    PE: {
        en: 'Peru',
        cn: '秘鲁',
        tw: '秘魯',
        jp: 'ペルー',
        de: 'Peru'
    },
    PH: {
        en: 'Philippines',
        cn: '菲律宾',
        tw: '菲律賓',
        jp: 'フィリピン',
        de: 'Philippinen'
    },
    PL: {
        en: 'Poland',
        cn: '波兰',
        tw: '波蘭',
        jp: 'ポーランド',
        de: 'Polen'
    },
    PT: {
        en: 'Portugal',
        cn: '葡萄牙',
        tw: '葡萄牙',
        jp: 'ポルトガル',
        de: 'Portugal'
    },
    RO: {
        en: 'Romania',
        cn: '罗马尼亚',
        tw: '羅馬尼亞',
        jp: 'ルーマニア',
        de: 'Rumänien'
    },
    RS: {
        en: 'Republic of Serbia',
        cn: '塞尔维亚共和国',
        tw: '塞爾維亞共和國',
        jp: 'セルビア共和国',
        de: 'Serbischen Republik'
    },
    RU: {
        en: 'Russia',
        cn: '俄罗斯',
        tw: '俄羅斯',
        jp: 'ロシア',
        de: 'Russland'
    },
    SE: {
        en: 'Sweden',
        cn: '瑞典',
        tw: '瑞典',
        jp: 'スウェーデン',
        de: 'Schweden'
    },
    SG: {
        en: 'Singapore',
        cn: '新加坡',
        tw: '新加坡',
        jp: 'シンガポール',
        de: 'Singapur'
    },
    SI: {
        en: 'Slovenia',
        cn: '斯洛文尼亚',
        tw: '斯洛文尼亞',
        jp: 'スロベニア',
        de: 'Slowenien'
    },
    SK: {
        en: 'Slovakia',
        cn: '斯洛伐克',
        tw: '斯洛伐克',
        jp: 'スロバキア',
        de: 'Slowakei'
    },
    SM: {
        en: 'San Marino',
        cn: '圣马力诺',
        tw: '聖馬力諾',
        jp: 'サンマリノ',
        de: 'San Marino'
    },
    SU: {
        en: 'Soviet Union',
        cn: '前苏联',
        tw: '前蘇聯',
        jp: 'ソビエト連邦',
        de: 'Sowjetunion'
    },
    SV: {
        en: 'El Salvador',
        cn: '萨尔瓦多',
        tw: '薩爾瓦多',
        jp: 'エルサルバドル',
        de: 'El Salvador'
    },
    TJ: {
        en: 'Tajikistan',
        cn: '塔吉克斯坦',
        tw: '塔吉克斯坦',
        jp: 'タジキスタン',
        de: 'Tadschikistan'
    },
    TR: {
        en: 'Turkey',
        cn: '土耳其',
        tw: '土耳其',
        jp: 'トルコ',
        de: 'Türkei'
    },
    TW: {
        en: 'Chinese Taiwan',
        cn: '中国台湾',
        tw: '中國台灣',
        jp: '中国台湾',
        de: 'Chinese Taiwan'
    },
    UA: {
        en: 'Ukraine',
        cn: '乌克兰',
        tw: '烏克蘭',
        jp: 'ウクライナ',
        de: 'Ukraine'
    },
    US: {
        en: 'United States',
        cn: '美国',
        tw: '美國',
        jp: 'アメリカ',
        de: 'Vereinigte Staaten'
    },
    UY: {
        en: 'Uruguay',
        cn: '乌拉圭',
        tw: '烏拉圭',
        jp: 'ウルグアイ',
        de: 'Uruguay'
    },
    VN: {
        en: 'Vietnam',
        cn: '越南',
        tw: '越南',
        jp: 'ベトナム',
        de: 'Vietnam'
    },
    WO: {
        en: 'WIPO',
        cn: '世界知识产权组织',
        tw: '世界知識產權組織',
        jp: '世界知的所有権機関',
        de: 'WIPO'
    },
    YU: {
        en: 'Yugoslavia',
        cn: '南斯拉夫',
        tw: '南斯拉夫',
        jp: 'ユーゴスラビア',
        de: 'Jugoslawien'
    },
    ZA: {
        en: 'South Africa',
        cn: '南非',
        tw: '南非',
        jp: '南アフリカ',
        de: 'Südafrika'
    },
    ZM: {
        en: 'Zambia',
        cn: '赞比亚',
        tw: '贊比亞',
        jp: 'ザンビア',
        de: 'Sambia'
    },
    ZW: {
        en: 'Zimbabwe',
        cn: '津巴布韦',
        tw: '津巴布韋',
        jp: 'ジンバブエ',
        de: 'Zimbabwe'
    },
    BX: {
        en: 'Benelux',
        cn: '比荷卢经济联盟',
        tw: '比荷盧經濟聯盟',
        jp: 'ベネルクス',
        de: 'Benelux'
    },
    AE: {
        en: 'United Arab Emirates',
        cn: '阿拉伯联合酋长国',
        tw: '阿拉伯聯合酋長國',
        jp: 'アラブ首長国連邦',
        de: 'Vereinigte Arabische Emirate'
    },
    AM: {
        en: 'Armenia',
        cn: '亚美尼亚',
        tw: '亞美尼亞',
        jp: 'アルメニア',
        de: 'Armenien'
    },
    BH: {
        en: 'Bahrain',
        cn: '巴林',
        tw: '巴林',
        jp: 'バーレーン',
        de: 'Bahrain'
    },
    BN: {
        en: 'Brunei Darussalam',
        cn: '文莱',
        tw: '文萊',
        jp: 'ブルネイ',
        de: 'Brunei Darussalam'
    },
    BO: {
        en: 'Bolivia',
        cn: '玻利维亚',
        tw: '玻利維亞',
        jp: 'ボリビア',
        de: 'Bolivien'
    },
    JO: {
        en: 'Jordan',
        cn: '约旦',
        tw: '約旦',
        jp: 'ヨルダン',
        de: 'Jordanien'
    },
    KG: {
        en: 'Kyrgyzstan',
        cn: '吉尔吉斯斯坦',
        tw: '吉爾吉斯斯坦',
        jp: 'キルギス',
        de: 'Kyrgyzstan'
    },
    KH: {
        en: 'Cambodia',
        cn: '柬埔寨',
        tw: '柬埔寨',
        jp: 'カンボジア',
        de: 'Kambodscha'
    },
    LA: {
        en: "Lao People's Democratic Republic",
        cn: '老挝',
        tw: '老撾',
        jp: 'ラオス',
        de: 'Demokratische Volksrepublik Laos'
    },
    LB: {
        en: 'Lebanon',
        cn: '黎巴嫩',
        tw: '黎巴嫩',
        jp: 'レバノン',
        de: 'Libanon'
    },
    MA: {
        en: 'Morocco',
        cn: '摩洛哥',
        tw: '摩洛哥',
        jp: 'モロッコ',
        de: 'Marokko'
    },
    ME: {
        en: 'Montenegro',
        cn: '黑山共和国',
        tw: '黑山共和國',
        jp: 'モンテネグロ',
        de: 'Montenegro'
    },
    MK: {
        en: 'The Republic of North Macedonia',
        cn: '北马其顿共和国',
        tw: '北馬其頓共和國',
        jp: '北マケドニア共和国',
        de: 'Die Republik Nordmakedonien'
    },
    PY: {
        en: 'Paraguay',
        cn: '巴拉圭',
        tw: '巴拉圭',
        jp: 'パラグアイ',
        de: 'Paraguay'
    },
    SA: {
        en: 'Saudi Arabia',
        cn: '沙特阿拉伯',
        tw: '沙特阿拉伯',
        jp: 'サウジアラビア',
        de: 'Saudi Arabien'
    },
    TN: {
        en: 'Tunisia',
        cn: '突尼斯',
        tw: '突尼斯',
        jp: 'チュニジア',
        de: 'Tunesien'
    },
    TT: {
        en: 'Trinidad and Tobago',
        cn: '特立尼达和多巴哥',
        tw: '特立尼達和多巴哥',
        jp: 'トリニダード・トバゴ',
        de: 'Trinidad und Tobago'
    },
    UZ: {
        en: 'Uzbekistan',
        cn: '乌兹别克斯坦',
        tw: '烏茲別克斯坦',
        jp: 'ウズベキスタン',
        de: 'Usbekistan'
    },
    VE: {
        en: 'Venezuela',
        cn: '委内瑞拉',
        tw: '委內瑞拉',
        jp: 'ベネズエラ',
        de: 'Venezuela'
    },
    TH: {
        en: 'Thailand',
        cn: '泰国',
        tw: '泰國',
        jp: 'タイ',
        de: 'Thailand'
    },
    MO: {
        en: 'China Macao',
        cn: '中国澳门',
        tw: '中國澳門',
        jp: '中国マカオ',
        de: 'China Macao'
    },
    BW: {
        cn: '博茨瓦纳',
        en: 'Botswana',
        tw: '博茨瓦納',
        jp: 'ボツワナ',
        de: 'Botswana'
    },
    GH: {
        cn: '加纳',
        en: 'Ghana',
        tw: '加納',
        jp: 'ガーナ',
        de: 'Ghana'
    },
    MZ: {
        en: 'Mozambique',
        cn: '莫桑比克',
        tw: '莫桑比克',
        jp: 'モザンビーク',
        de: 'Mosambiks'
    },
    RW: {
        cn: '卢旺达',
        en: 'Rwanda',
        tw: '盧旺達',
        jp: 'ルワンダ',
        de: 'Ruanda'
    },
    TZ: {
        cn: '坦桑尼亚',
        en: 'Tanzania',
        tw: '坦桑尼亞',
        jp: 'タンザニア',
        de: 'Tansania'
    },
    SY: {
        cn: '叙利亚',
        en: 'Syria',
        tw: '敘利亞',
        jp: 'シリア',
        de: 'Syrien'
    },
    AZ: {
        cn: '阿塞拜疆',
        en: 'Azerbaijan',
        tw: '阿塞拜疆',
        jp: 'アゼルバイジャン',
        de: ''
    },
    PG: {
        cn: '巴布亚新几内亚',
        en: 'Papua New Guinea',
        tw: '巴布亞新幾內亞',
        jp: 'パプアニューギニア',
        de: 'Papua-Neuguinea'
    },
    BD: {
        cn: '孟加拉国',
        en: 'Bangladesh',
        tw: '孟加拉國',
        jp: 'バングラデシュ',
        de: 'Bangladesch'
    },
    BZ: {
        cn: '伯利兹',
        en: 'Belize',
        tw: '伯利茲',
        jp: 'ベリーズ',
        de: 'Belize'
    },
    AD: {
        cn: '安道尔',
        en: 'Andorra',
        tw: '安道爾',
        jp: 'アンドラ',
        de: 'Andorra'
    },
    AL: {
        cn: '阿尔巴尼亚',
        en: 'Albania',
        tw: '阿爾巴尼亞',
        jp: 'アルバニア',
        de: 'Albanien'
    },
    AO: {
        cn: '安哥拉',
        en: 'Angola',
        tw: '安哥拉',
        jp: 'アンゴラ',
        de: 'Angola'
    },
    BB: {
        cn: '巴巴多斯',
        en: 'Barbados',
        tw: '巴巴多斯',
        jp: 'バルバドス',
        de: 'Barbados'
    },
    BS: {
        cn: '巴哈马',
        en: 'Bahamas',
        tw: '巴哈馬',
        jp: 'バハマ',
        de: 'Bahamas'
    },
    BT: {
        cn: '不丹',
        en: 'Bhutan',
        tw: '不丹',
        jp: 'ブータン',
        de: 'Bhutan'
    },
    CG: {
        cn: '刚果(布)',
        en: 'Congo',
        tw: '剛果(布)',
        jp: 'コンゴ',
        de: 'Kongo'
    },
    CV: {
        cn: '佛得角',
        en: 'Cape Verde',
        tw: '佛得角',
        jp: 'カーボベルデ',
        de: 'Kap Verde'
    },
    DJ: {
        cn: '吉布提',
        en: 'Djibouti',
        tw: '吉布提',
        jp: 'ジブチ',
        de: 'Dschibuti'
    },
    DM: {
        cn: '多米尼克',
        en: 'Dominica',
        tw: '多米尼克',
        jp: 'ドミニカ国',
        de: 'Dominica'
    },
    ET: {
        cn: '埃塞俄比亚',
        en: 'Ethiopia',
        tw: '埃塞俄比亞',
        jp: 'エチオピア',
        de: 'Äthiopien'
    },
    FJ: {
        cn: '斐济',
        en: 'Fiji',
        tw: '斐濟',
        jp: 'フィジー',
        de: 'Fidschi'
    },
    GY: {
        cn: '圭亚那',
        en: 'Guyana',
        tw: '圭亞那',
        jp: 'ガイアナ',
        de: 'Guyana'
    },
    IQ: {
        cn: '伊拉克',
        en: 'Iraq',
        tw: '伊拉克',
        jp: 'イラク',
        de: 'Irak'
    },
    IR: {
        cn: '伊朗',
        en: 'Iran',
        tw: '伊朗',
        jp: 'イラン',
        de: 'Iran'
    },
    KY: {
        cn: '开曼群岛',
        en: 'Cayman Islands',
        tw: '開曼群島',
        jp: 'ケイマン諸島',
        de: 'Kaimaninseln'
    },
    LK: {
        cn: '斯里兰卡',
        en: 'Sri Lanka',
        tw: '斯裏蘭卡',
        jp: 'スリランカ',
        de: 'Sri Lanka'
    },
    MG: {
        cn: '马达加斯加',
        en: 'Madagascar',
        tw: '馬達加斯加',
        jp: 'マダガスカル',
        de: 'Madagaskar'
    },
    MM: {
        cn: '缅甸',
        en: 'Myanmar',
        tw: '緬甸',
        jp: 'ミャンマー',
        de: 'Myanmar'
    },
    MS: {
        cn: '蒙特塞拉特',
        en: 'Montserrat',
        tw: '蒙特塞拉特',
        jp: 'モントセラト',
        de: 'Montserrat'
    },
    MU: {
        cn: '毛里求斯',
        en: 'Mauritius',
        tw: '毛裏求斯',
        jp: 'モーリシャス',
        de: 'Mauritius'
    },
    OM: {
        cn: '阿曼',
        en: 'Oman',
        tw: '阿曼',
        jp: 'オマーン',
        de: 'Oman'
    },
    PK: {
        cn: '巴基斯坦',
        en: 'Pakistan',
        tw: '巴基斯坦',
        jp: 'パキスタン',
        de: 'Pakistan'
    },
    PS: {
        cn: '巴勒斯坦',
        en: 'Palestine',
        tw: '巴勒斯坦',
        jp: 'パレスチナ',
        de: 'Palästina'
    },
    QA: {
        cn: '卡塔尔',
        en: 'Qatar',
        tw: '卡塔爾',
        jp: 'カタール',
        de: 'Katar'
    },
    SD: {
        cn: '苏丹',
        en: 'Sudan',
        tw: '蘇丹',
        jp: 'スーダン',
        de: 'Sudan'
    },
    ST: {
        cn: '圣多美和普林西比',
        en: 'Sao Tome and Principe',
        tw: '聖多美和普林西比',
        jp: 'サントメ・プリンシペ',
        de: 'Sao Tome und Principe'
    },
    TM: {
        cn: '土库曼斯坦',
        en: 'Turkmenistan',
        tw: '土庫曼斯坦',
        jp: 'トルクメニスタン',
        de: 'Turkmenistan'
    },
    VC: {
        cn: '圣文森特和格林纳丁斯',
        en: 'Saint Vincent and the Grenadines',
        tw: '聖文森特和格林納丁斯',
        jp: 'セントビンセントおよびグレナディーン諸島',
        de: 'St. Vincent und die Grenadinen'
    },
    VG: {
        cn: '英属维尔京群岛',
        en: 'British Virgin Islands',
        tw: '英屬維爾京群島',
        jp: '英領ヴァージン諸島',
        de: 'Jungferninseln'
    },
    XK: {
        cn: '科索沃',
        en: 'Republic of Kosovo',
        tw: '科索沃',
        jp: 'コソボ',
        de: 'Kosovo'
    },
    YE: {
        cn: '也门',
        en: 'Yemen',
        tw: '也門',
        jp: 'イエメン',
        de: 'Jemen'
    },
    AG: {
        cn: '安提瓜和巴布达',
        en: 'Antigua and Barbuda',
        tw: '安提瓜和巴布達',
        jp: 'アンティグア・バーブーダ',
        de: 'Antigua und Barbuda'
    },
    NA: {
        cn: '纳米比亚',
        en: 'Namibia',
        tw: '納米比亞',
        jp: 'ナミビア',
        de: 'Namibia'
    },
    UG: {
        cn: '乌干达',
        en: 'Uganda',
        tw: '烏幹達',
        jp: 'ウガンダ',
        de: 'Uganda'
    },
    ZN: {
        cn: '桑给巴尔',
        en: 'Zanzibar',
        tw: '桑給巴爾',
        jp: 'ザンジバル',
        de: 'Sansibar'
    },
    AI: {
        cn: '安圭拉',
        en: 'Anguilla',
        tw: '安圭拉',
        jp: 'アンギラ',
        de: 'Anguilla'
    },
    JE: {
        cn: '泽西',
        en: 'Jersey',
        tw: '澤西',
        jp: 'ジャージー',
        de: 'Jersey'
    },
    AW: {
        en: 'Aruba',
        cn: '阿鲁巴',
        tw: '阿魯巴',
        jp: 'アルバ',
        de: 'Aruba'
    },
    BM: {
        en: 'Bermuda',
        cn: '百慕大',
        tw: '百慕大',
        jp: 'バミューダ',
        de: 'Bermudas'
    },
    CD: {
        en: 'Democratic Republic of the Congo',
        cn: '刚果(金)',
        tw: '剛果(金)',
        jp: 'コンゴ民主共和国',
        de: 'Kongo (Kinshasa)'
    },
    NG: {
        cn: '尼日利亚',
        en: 'Nigeria',
        tw: '尼日利亞',
        jp: 'ナイジェリア',
        de: 'Nigeria'
    },
    SB: {
        cn: '所罗门群岛',
        en: 'Solomon Islands',
        tw: '所羅門群島',
        jp: 'ソロモン諸島',
        de: 'Salomon-Inseln'
    },
    SC: {
        cn: '塞舌尔',
        en: 'Seychelles',
        tw: '塞舌爾',
        jp: 'セイシェル',
        de: 'Seychellen'
    },
    LI: {
        cn: '列支敦士登',
        en: 'Liechtenstein',
        tw: '列支敦士登',
        jp: 'リヒテンシュタイン',
        de: 'Liechtenstein'
    },
    TC: {
        cn: '特克斯和凯科斯群岛',
        en: 'Turks and Caicos Islands',
        tw: '特克斯和凱科斯群島',
        jp: 'タ—クス．カイコス诸岛',
        de: 'Turks and Caicos Islands'
    },
    TO: {
        cn: '汤加',
        en: 'Tonga',
        tw: '湯加',
        jp: 'トンガ',
        de: 'Tonga'
    },
    WS: {
        cn: '萨摩亚',
        en: 'Samoa',
        tw: '薩摩亞',
        jp: 'サモア',
        de: 'Samoa'
    }
};
